import { render, staticRenderFns } from "./ContentThirdTab.vue?vue&type=template&id=5182c394&"
import script from "./ContentThirdTab.vue?vue&type=script&lang=js&"
export * from "./ContentThirdTab.vue?vue&type=script&lang=js&"
import style0 from "./ContentThirdTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
